import Crud from '../views/Classification/Crud'
import Entity from '../views/Classification/Add'

let routes = {
    path: '/classifications',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/classifications/add',
            name: 'NewClassification',
            component: Entity,
            meta: {
                pageTitle: 'Classificação',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Adicionar Classificação',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/classifications/edit/:id?',
            name: 'EditClassification',
            component: Entity,
            meta: {
                pageTitle: 'Classificação',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Editar Classificação',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/classifications',
            name: 'list-classifications',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Classificações',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Classificações',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
